import React, {useEffect} from 'react';
import AutosizeInput from 'react-input-autosize';

import styles from './editable-label-button.module.css';

type Props = {
    value: string;
    onSaveNewValue: (arg1: string) => Promise<any>;
    customStyle?: any;
};

export function EditableLabelButton(props: Props) {
    const [isEditing, setIsEditing] = React.useState<boolean>(false);
    const [value, setValue] = React.useState<string>(props.value);

    const inputRef = React.useRef();

    useEffect(() => {
        if (isEditing && inputRef && inputRef.current) {
            // @ts-expect-error
            inputRef.current.select();
        }
    }, [inputRef, isEditing]);

    // These styles make the AutosizeInput match the button so there's no adjustment when editing
    const inputStyle = {
        lineHeight: '1.4',
        padding: '8px 7px 8px 8px',
        border: 'none',
        outline: 'none',
    } as const;

    return (
        <div className={styles.container}>
            {isEditing ? (
                <AutosizeInput
                    inputStyle={{
                        ...props.customStyle,
                        ...inputStyle,
                    }}
                    value={value}
                    autoFocus={true}
                    onChange={(e) => {
                        setValue(e.target.value);
                    }}
                    onBlur={() => {
                        props.onSaveNewValue(value);
                        setIsEditing(false);
                    }}
                    // @ts-expect-error
                    ref={(node) => {
                        inputRef.current = node;
                    }}
                    maxLength={32}
                />
            ) : (
                <button
                    onClick={() => setIsEditing(true)}
                    style={props.customStyle}
                    className={styles.button}
                >
                    {value}
                </button>
            )}
        </div>
    );
}
